import React from 'react';

import { Content } from 'LegacySBCRA/Content/Content';

import { ContentArea, ExpandableSection } from '../../../fastlane/expandableSection/ExpandableSection';

import styles from './ExpandableContentWrapper.scss';

type ExpandableContentWrapperProps = {
  faq: ContentArea[];
  faqTitle: string;
  onLoad: () => void;
};

export const ExpandableContentWrapper = ({ faq, faqTitle, onLoad }: ExpandableContentWrapperProps) => (
  <Content className={styles.expandableSectionWrapper}>
    <ExpandableSection
      className={styles.expandableSection}
      content={faq}
      onSectionLoaded={onLoad}
      title={faqTitle}
    />
  </Content>
);
